export enum Teinte {
    Incolore = 1,
    Bleu = 2,
    BleuVert = 3,
    Vert = 4,
    VertJaune = 5,
    Jaune = 6,
    JauneMarron = 7,
    MarronClair = 8,
    MarronFonce = 9,
    Gris = 10,
    Noir = 11,
    Blanc = 12
}
